<a
  (click)="markMailAsRead(mail.id)"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
  [class.mail-row--selected]="selected"
  [class.mail-row--unread]="!mail.read"
  [class.mail-row--blocked]="mail.blockedInfo?.isBlocked"
  class="mail-row flex px-4 py-4 transition ease-in-out duration-200"
  href="javascript:void(0)">
  <div class="flex-none flex flex-col ltr:pr-4 rtl:pl-4">
    <div
      [class.hidden]="isCheckboxVisible()"
      class="w-9 h-9 rounded-full overflow-hidden mt-1 flex-none">
      <img [src]="mail.from.imgUrl" class="w-full h-full object-fit" />
    </div>

    <div
      [class.hidden]="!isCheckboxVisible()"
      class="w-9 h-9 text-center flex-none">
      <mat-checkbox
        (change)="onCheckboxChange($event)"
        (click)="$event.stopPropagation()"
        [checked]="selected"
        class="-ml-1"
        color="primary"></mat-checkbox>
    </div>

    <div class="flex-1"></div>

    <div
      (click)="toggleStar($event)"
      [class.hidden]="!isStarVisible()"
      class="flex-none mx-auto p-1 rounded-full hover:bg-hover relative block"
      matRipple>
      <mat-icon
        [class.text-amber-600]="mail.starred"
        [svgIcon]="mail.starred ? 'mat:star' : 'mat:star_border'"
        class="icon-sm block"></mat-icon>
    </div>
  </div>

  <div class="truncate w-full">
    <div class="flex items-end">
      <p
        [ngClass]="{ 'font-bold text-default': !mail.read }"
        class="flex-auto text-[17px] leading-snug text-default font-semibold">
        {{ mail.from.name }}
      </p>
      <p
        [ngClass]="{ 'font-semibold text-default': !mail.read }"
      class="flex-none text-[13px] leading-normal text-secondary">
        {{ mail.date | vexDateFormatRelative }}
      </p>
    </div>
    <p
      [ngClass]="{ 'font-bold text-default': !mail.read }"
      class="text-[15px] leading-snug truncate text-default font-semibold mt-0.5">
      {{ mail.subject }}
    </p>
    <div class="flex items-start mt-1.5">
      <p class="text-[13px] text-secondary leading-snug truncate">
        {{ mail.body | vexStripHtml }}
      </p>
      <mat-icon
        *ngIf="mail.hasAttachments"
        class="ml-2 icon-sm text-secondary"
        svgIcon="mat:attach_file"></mat-icon>
      <vex-mail-label
        *ngFor="let label of mail.labels"
        [label]="label.label"
        [ngClass]="label.classes"
        class="ml-2 text-2xs"></vex-mail-label>
    </div>
    <div class="mail-row__meta mt-2 flex items-center gap-2" *ngIf="mail.folder === 'DRAFT' || !mail.read || mail.starred || mail.blockedInfo?.isBlocked">
      <span *ngIf="mail.folder === 'DRAFT'" class="mail-row__status mail-row__status--draft">Draft</span>
      <span *ngIf="!mail.read" class="mail-row__status mail-row__status--unread">Unread</span>
      <span *ngIf="mail.starred" class="mail-row__status mail-row__status--important">Important</span>
      <span *ngIf="mail.blockedInfo?.isBlocked" class="mail-row__status mail-row__status--blocked">Suspicious</span>
    </div>
  </div>
</a>
